import isUndefined from "lodash/isUndefined";
import find from "lodash/find";
import flatten from "lodash/flatten";
import flattenDeep from "lodash/flattenDeep";
import get from "lodash/get";
import findIndex from "lodash/findIndex";

const InterviewUtils = {
  depth(questions, question, currentDepth) {
    const parentChildTree = InterviewUtils.generateParentChildTree(questions);

    if (isUndefined(question.id)) {
      return 0;
    }
    if (!currentDepth) {
      return find(parentChildTree, { childId: question.id }).depth;
    }
  },

  flattenQuestions(questionData) {
    // Clone the original.
    let result = questionData.map((question) => {
      const intermediateResult = [question];
      if (question.questions) {
        intermediateResult.push(this.flattenQuestions(question.questions));
      }
      return flatten(intermediateResult);
    });

    result = flatten(result);

    return result;
  },

  parentQuestion(questions, question) {
    if (!question) {
      return null;
    }

    const parentChildTree = InterviewUtils.generateParentChildTree(questions);
    const node = find(parentChildTree, {
      childId: question.id,
    });

    return node && node.parent;
  },

  generateParentChildTree(questions, depth) {
    if (isUndefined(depth)) {
      depth = 1;
    }

    return flattenDeep([
      questions.questions.map((question) => {
        const result = [];
        const node = {
          childId: question.id,
          parentId: questions.id,
          child: question,
          parent: questions,
          depth,
        };

        result.push(node);

        if (question.questions) {
          result.push(
            InterviewUtils.generateParentChildTree(question, depth + 1),
          );
        }

        return result;
      }),
    ]);
  },

  findQuestionIndex(questions, question) {
    return findIndex(questions, (item) => item.id === get(question, "id"));
  },
};

export default InterviewUtils;
